import { AnalyticsEventTypes, Blocks } from "./consts";
import { Provider } from "./provider";
import { useAnalytics } from "./useAnalytics";

const Analytics = {
  Provider,
  useAnalytics,
  AnalyticsEventTypes,
  Blocks,
};

export default Analytics;
